module.exports = __webpack_public_path__ + "static/hif-graphic-3c5805284012c73d2be6df2b2aee4f62.jpg";